<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" scrollable :mask="false" draggable class="insert_webpage_pop bindpublic">
    <p style="color:red">请联系客服获取IP地址或域名,添加到微信公众平台-开发-基本配置IP白名单中</p>
    <p style="color:red">绑定完成后请点击编辑，在编辑页面中进行下一步配置</p>
    <p>&nbsp;</p>
    <div class="insert_name">
      <div class="font_style_set" style="width:30%">公众号名称:<span style="color: red">*</span></div>
      <Input v-model = "channelName" class="config_content" placeholder="请输入公众号名称" title="公众号名称" style="width:68%"/>
    </div>
    <div class="webpage_text_area">
      <div class="font_style_set" style="width:30%">微信AppID(开发者ID):<span style="color: red">*</span></div>
      <Input v-model = "channelAppId" class="config_content" placeholder="请输入微信AppID" title="微信AppID" style="width:68%;margin-top:20px"/>
    </div>
    <div class="insert_name">
      <div class="font_style_set" style="width:30%">开发者秘钥(AppSecret):<span style="color: red">*</span></div>
      <Input v-model = "channelAppSecret" class="config_content" placeholder="请输入开发者秘钥" title="开发者秘钥" style="width:68%;margin-top:10px"/>
    </div>
    <div class="webpage_text_area" v-if="false">
      <div class="font_style_set" style="width:30%">消息加密密钥:</div>
      <Input v-model="channelKey" class="config_content" placeholder="请输入消息加密密钥" title="消息加密密钥" style="width:68%;margin-top:20px"/>
    </div>
    <div slot="footer">
      <Button  type="primary" class="submit_btn" @click="savedeveper()">确认</Button>
      <Button type="error" class="cancel_btn"  @click="cancel()">取消</Button>
    </div>
  </Modal>
</template>

<script>
import {publicFunClass} from '@/components/js/PublicFunClass.js'

export default {
  name: 'DeveloperPop',
  mixins: [publicFunClass],
  props: {
    showDeveloper: Boolean,
    channelType: String
  },
  data() {
    return {
      model: false,
      title: '绑定公众号',
      channelName: '',
      channelAppId: '',
      channelAppSecret: '',
      channelKey: ''
    }
  },
  methods: {
    cancel: function () {
      this.channelName = '';
      this.channelAppId = '';
      this.channelAppSecret = '';
      this.channelKey = '';
      this.$emit('closeDeveloper', false);
    },
    savedeveper:function () {
      let journalType = "";
      let menuId = "";
      if(this.channelType == "-8"){
        journalType = "系统管理=>会话配置=>渠道管理=>绑定公众号";
        menuId = "3_12-1-6";
        if(!this.channelName){
              this.$Modal.info({
                title:'提示',
                content:"公众号名称不能为空"
              });
              return false;
        }
          if(!this.channelAppId){
              this.$Modal.info({
                title:'提示',
                content:"微信AppID不能为空"
              });
              return false;
        }
        if(!this.channelAppSecret){
              this.$Modal.info({
                title:'提示',
                content:"开发者秘钥不能为空"
              });
              return false;
        }
      }else if(this.channelType == "-9"){
        journalType = "系统管理=>会话配置=>渠道管理=>绑定小程序";
        menuId = "3_12-1-7";
      }
      let param = {
            "channelType": this.channelType,
            "channelName": this.channelName,
            "channelAppId": this.channelAppId,//微信AppID(开发者ID)
            "channelAppSecret": this.channelAppSecret,//开发者秘钥
            "channelKey": this.channelKey,//消息加密秘钥
            "channelMode": '2',
            "channelPeriod": '0',
            "journalType": journalType,
            "menuId": menuId
          }
          let that = this;
          this.$http.post("chat/channel/doSave.json",param) .then(function (res) {
            let result=res.data;
            that.spinShow=false;
            if(result.flag!="666"){
              that.$Message.error(result.msg);
              return false;
            }
            that.$Message.success({
                content: "绑定成功，请前往自定义菜单中开启人工客服配置，正常使用在线客服功能",
                duration: 3
            });
            that.cancel();
          })
    },
  },
  watch: {
    showDeveloper: function () {
      this.model = this.showDeveloper
      let that = this;
      if(this.channelType == '-8'){
        this.title = '绑定公众号'
      }else if(this.channelType == '-9'){
        this.title = "绑定小程序";
      }

    }
  }

}
</script>

<style scoped >

</style>




// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/DeveloperPop.vue